import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import ReactPlaceholder from 'react-placeholder/lib';
import styles from './PricingBadge.module.scss';

export enum PricingBadgeSize {
  sm = 'sm',
  md = 'md',
}
export interface PricingBadge {
  discount: string;
  fontSize?: PricingBadgeSize;
}

const PricingBadge: FC<PricingBadge> = ({ discount, fontSize = PricingBadgeSize.md }) => {
  const { t } = useTranslation();

  if (!discount) {
    return null;
  }

  return (
    <div className={styles.productTitle}>
      <ReactPlaceholder
        showLoadingAnimation
        type="textRow"
        ready={!!discount}
        style={{ width: '100%', backgroundColor: '#e8e8e8' }}
      >
        <div className={styles.discountContainer}>
          <div className={cn(styles.discountPrice, styles[`size-${fontSize}`])}>
            {discount}% {t('txt_off')}
          </div>
        </div>
      </ReactPlaceholder>
    </div>
  );
};

export default PricingBadge;
